export default (state = [], action) => {
  switch (action.type) {
    case "CREATE_CHILD_WELFARE_HISTORY":
      return [...state, action.payload.childWelfareHistory];
    case "UPDATE_CHILD_WELFARE_HISTORY":
      return action.payload.childWelfareHistory;
    case "DELETE_CHILD_WELFARE_HISTORY":
      return state.filter((childWelfareHistory) => {
        return childWelfareHistory.id !== action.payload.childWelfareHistory.id;
      });
    default:
      return state;
  }
};
